import { createSlice } from "@reduxjs/toolkit";

const ConfigurationReducer = createSlice({
  name: "ConfigurationReducer",
  initialState: {
     config: {},
  },
  reducers: {
    setField(state, action) {
      state[action.payload.name] = action.payload.value;
    },
    
  },
});

export const {
  setField,

} = ConfigurationReducer.actions;
export default ConfigurationReducer.reducer;
